import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  GetGrihaLeadDetails,
  UpdateGrihaLeadDetails,
} from "../../Services/Griha/Lead";
import Toast from "../../Components/Alerts/Toast";
import Stepper from "../Layout/Stepper";

const CustomerDetails = () => {
  const { uid } = useParams();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [premium, setPremium] = useState({});
  const [toast, setToast] = useState({ message: "", type: "" });
  const [errors, setErrors] = useState({
    title: "",
    insuredName: "",
    contactNumber: "",
    email: "",
    dateOfBirth: "",
    documentType: "",
    documentNumber: "",
  });
  const validateCustomerDetails = () => {
    let newErrors = {};

    if (!form.title || form.title === "Select")
      newErrors.title = "Select a title";
    if (!form.insuredName) newErrors.insuredName = "Full Name is required";
    if (!form.contactNumber)
      newErrors.contactNumber = "Contact mobile number is required";
    if (!form.dateOfBirth) newErrors.dateOfBirth = "Date of birth is required";
    if (!form.documentType || form.documentType === "Select")
      newErrors.documentType = "Select a document type";
    if (!form.documentNumber)
      newErrors.documentNumber = "Provide a document number";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const validatePropertyDetails = () => {
    let newErrors = {};

    if (!form.constructionType || form.constructionType === "Select") {
      newErrors.constructionType = "Select a construction type";
    }

    if (!form.ownershipType || form.ownershipType === "Select") {
      newErrors.ownershipType = "Select a ownership type";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const validateAddressDetails = () => {
    let newErrors = {};

    if (!form.communicationAddress)
      newErrors.communicationAddress = "Communication Address is required";
    if (!form.pinCode) newErrors.pinCode = "Pin Code is required";
    if (!form.district) newErrors.district = "District is required";
    if (!form.state) newErrors.state = "State is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const validateNomineeDetails = () => {
    let newErrors = {};

    if (!form.nomineeName) newErrors.nomineeName = "Nominee Name is required";
    if (!form.constructionType || form.constructionType === "Select") {
      newErrors.constructionType = "Select a Nominee Relation";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };

  const formatDateToInput = (dateStr) => {
    if (!dateStr) return "";
    const [datePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("-");
    if (!day || !month || !year) return "";
    return `${year}-${month}-${day}`;
  };

  const [form, setForm] = useState({
    title: "",
    insuredName: "",
    contactNumber: "",
    dateOfBirth: "",
    email: "",
    pinCode: "",
    district: "",
    state: "",
    communicationAddress: "",
    nomineeName: "",
    nomineeRelation: "",
    nomineeDateOfBirth: "",
    nomineeContactNumber: "",
    nomineeDocumentType: "",
    nomineeDocumentNumber: "",
    constructionType: "",
    ownershipType: "",
    documentType: "",
    documentNumber: "",
  });

  useEffect(() => {
    loadLeadDetails();
  }, []);

  const loadLeadDetails = async () => {
    try {
      const res = await GetGrihaLeadDetails(uid);

      if (!res || res.data.status !== "Success") {
        showToast("Lead not found", "error");
        setLoading(false);
        return;
      }

      const { lead, address, premium, nominee } = res.data;

      setPremium(premium || {});

      setForm((prev) => ({
        ...prev,
        title: lead?.title || "",
        insuredName: lead?.insuredName || "",
        contactNumber: lead?.contactNumber || "",
        dateOfBirth: formatDateToInput(lead?.dateOfBirth),
        email: lead?.email || "",
        documentType: lead?.documentType || "",
        documentNumber: lead?.documentNumber || "",
        pinCode: address?.pinCode || "",
        district: address?.district || "",
        state: address?.state || "",
        communicationAddress: address?.communicationAddress || "",
        constructionType: address?.constructionType || "",
        ownershipType: address?.ownershipType || "",
        nomineeName: nominee?.nomineeName || "",
        nomineeRelation: nominee?.nomineeRelation || "",
        nomineeDateOfBirth: formatDateToInput(nominee?.nomineeDateOfBirth),
        nomineeContactNumber: nominee?.nomineeContactNumber || "",
        nomineeDocumentType: nominee?.nomineeDocumentType || "",
        nomineeDocumentNumber: nominee?.nomineeDocumentNumber || "",
      }));

      setLoading(false);
    } catch (err) {
      console.error(err);
      showToast("Something went wrong while loading details", "error");
      setLoading(false);
    }
  };

  const handleInputChange = (name) => (e) => {
    const value = e.target.value;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSelectChange = (name) => (e) => {
    const value = e.target.value;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handlePANInputChange = (name) => (e) => {
    let value = e.target.value;

    // auto uppercase + remove spaces
    if (name === "documentNumber") {
      value = value.toUpperCase().replace(/\s/g, "");

      if (form.documentType === "Aadhaar") {
        if (!/^\d{0,12}$/.test(value)) {
          return;
        }

        if (value.length === 12 && !/^\d{12}$/.test(value)) {
          setErrors({ documentNumber: "Enter valid 12 digit Aadhaar number" });
        } else {
          setErrors({ documentNumber: "" });
        }
      }

      if (form.documentType === "PAN") {
        if (!/^[A-Z0-9]*$/.test(value)) {
          return;
        }

        if (value.length === 10 && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value)) {
          setErrors({ documentNumber: "Enter valid PAN number" });
        } else {
          setErrors({ documentNumber: "" });
        }
      }
    }

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleNumberChange = (name) => (e) => {
    const value = e.target.value;

    // allow only digits and max length 10
    if (/^\d{0,10}$/.test(value)) {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleAddressInputChange = (name) => (e) => {
    let value = e.target.value;

    // Communication Address Validation
    if (name === "communicationAddress") {
      if (value.trim().length < 10) {
        setErrors((prev) => ({
          ...prev,
          communicationAddress: "Minimum 10 characters required",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          communicationAddress: "",
        }));
      }
    }

    // Pincode Validation
    if (name === "pinCode") {
      if (!/^[0-9]*$/.test(value)) return;

      // Length validation
      if (value.length !== 6) {
        setErrors((prev) => ({
          ...prev,
          pinCode: "Pincode must be 6 digits only",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          pinCode: "",
        }));
      }
    }
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveCustomerDetails = async () => {
    if (!validateDocument()) return;
    if (!validateCustomerDetails()) return;
    try {
      setSaving(true);

      const payload = {
        grihaLeadUID: uid || null,
        lead: {
          premiumID: premium?.premiumUID || null,
          grihaLeadUID: uid || null,
          grihaLeadNumber: null,
          title: form.title || null,
          insuredName: form.insuredName || null,
          contactNumber: form.contactNumber || null,
          dateOfBirth: form.dateOfBirth || null,
          email: form.email || null,
          documentType: form.documentType || null,
          documentNumber: form.documentNumber || null,
          gstn: null,
        },
      };

      const res = await UpdateGrihaLeadDetails(payload);

      if (res && res.data && res.data.status === "Success") {
        showToast("Details updated successfully", "success");
        // You can navigate to next step here if needed
        // navigate(`/griha/checkout/${uid}`);
      } else {
        showToast(res?.data?.message || "Failed to update details", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Error while updating details", "error");
    } finally {
      setSaving(false);
    }
  };
  const handleSaveAddress = async () => {
    if (!validateAddressDetails()) return;
    try {
      setSaving(true);

      const payload = {
        grihaLeadUID: uid || null,
        address: {
          pinCode: form.pinCode || null,
          district: form.district || null,
          state: form.state || null,
          communicationAddress: form.communicationAddress || null,
          permanentAddress: null,
        },
      };

      const res = await UpdateGrihaLeadDetails(payload);

      if (res && res.data && res.data.status === "Success") {
        showToast("Details updated successfully", "success");
        // You can navigate to next step here if needed
        // navigate(`/griha/checkout/${uid}`);
      } else {
        showToast(res?.data?.message || "Failed to update details", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Error while updating details", "error");
    } finally {
      setSaving(false);
    }
  };
  const handleSaveProperty = async () => {
    if (!validatePropertyDetails()) return;
    try {
      setSaving(true);

      const payload = {
        grihaLeadUID: uid || null,
        address: {
          constructionType: form.constructionType || null,
          ownershipType: form.ownershipType || null,
        },
      };

      const res = await UpdateGrihaLeadDetails(payload);

      if (res && res.data && res.data.status === "Success") {
        showToast("Details updated successfully", "success");
        // You can navigate to next step here if needed
        // navigate(`/griha/checkout/${uid}`);
      } else {
        showToast(res?.data?.message || "Failed to update details", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Error while updating details", "error");
    } finally {
      setSaving(false);
    }
  };
  const handleSave = async () => {
    if (!validateNomineeDetails()) return;
    try {
      setSaving(true);

      const payload = {
        grihaLeadUID: uid || null,
        lead: {
          premiumID: premium?.premiumUID || null,
          grihaLeadUID: uid || null,
          grihaLeadNumber: null,
          title: form.title || null,
          insuredName: form.insuredName || null,
          contactNumber: form.contactNumber || null,
          dateOfBirth: form.dateOfBirth || null,
          email: form.email || null,
          documentType: form.documentType || null,
          documentNumber: form.documentNumber || null,
          gstn: null,
        },
        address: {
          pinCode: form.pinCode || null,
          district: form.district || null,
          state: form.state || null,
          communicationAddress: form.communicationAddress || null,
          permanentAddress: null,
          constructionType: form.constructionType || null,
          ownershipType: form.ownershipType || null,
        },
        nominee: {
          nomineeName: form.nomineeName || null,
          nomineeRelation: form.nomineeRelation || null,
          nomineeDateOfBirth: form.nomineeDateOfBirth || null,
          nomineeContactNumber: form.nomineeContactNumber || null,
          nomineeDocumentType: form.nomineeDocumentType || null,
          nomineeDocumentNumber: form.nomineeDocumentNumber || null,
        },
        premium: {
          premiumUID: premium?.premiumUID || null,
          buildingSA: premium?.buildingSA ?? 1,
          contentSA: premium?.contentSA ?? 1,
          totalSA: premium?.totalSA ?? 1,
          premium: premium?.premium ?? 1,
          gst: premium?.gst ?? 1,
          totalPremium: premium?.totalPremium ?? 1,
        },
      };

      const res = await UpdateGrihaLeadDetails(payload);

      if (res && res.data && res.data.status === "Success") {
        showToast("Details updated successfully", "success");
        // You can navigate to next step here if needed
        // navigate(`/griha/checkout/${uid}`);
      } else {
        showToast(res?.data?.message || "Failed to update details", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Error while updating details", "error");
    } finally {
      setSaving(false);
    }
  };

  const validateDocument = () => {
    if (form.documentType === "Aadhaar") {
      const a = form.documentNumber.trim();
      if (!/^\d{12}$/.test(a)) {
        showToast("Enter valid Aadhaar number", "error");
        return false;
      }
    }

    if (form.documentType === "PAN") {
      const pan = form.documentNumber.toUpperCase().trim();
      if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
        showToast("Enter valid PAN number", "error");
        return false;
      }
    }

    return true;
  };

  if (loading)
    return <div className="p-20 text-center text-lg">Loading details...</div>;

  return (
    <div className="min-h-screen text-gray-800">
      <header className="bg-white border-b sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <Stepper
            currentStep={2}
            steps={["Select Plan", "Details", "Checkout", "Confirmation"]}
          />
        </div>
      </header>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-[30%_70%] gap-6 px-6 py-10 h-[calc(100vh-90px)]">
        {/* LEFT PANEL */}
        <div className="bg-white rounded-2xl border shadow p-6 h-fit lg:sticky lg:top-24">
          <h3 className="text-lg font-semibold border-b pb-2 mb-4">
            Premium Details
          </h3>

          <div className="flex items-center gap-3 mb-6">
            <img
              src="https://assets.futuregenerali.in/header-assets/updated-header-logo/logo.svg"
              alt="provider"
              className="h-12 object-contain"
            />
            <div className="h-14 w-px bg-gray-300"></div>
            <span className="font-medium text-gray-700 text-sm">
              Generali Central India Insurance Company
            </span>
          </div>

          <h4 className="text-sm font-semibold text-gray-600 tracking-wider mb-1">
            SUM ASSURED
          </h4>
          <Info label="Building" value={premium?.buildingSA} />
          <Info label="Content" value={premium?.contentSA} />
          <Info label="Total Sum Assured" value={premium?.totalSA} />
          <div className="my-3 border-b"></div>

          <h4 className="text-sm font-semibold text-gray-600 tracking-wider mb-1">
            PREMIUM BREAKUP
          </h4>
          <Info label="Base Premium" value={premium?.premium} />
          <Info label="GST" value={premium?.gst} />

          <div className="mt-4 font-bold text-xl text-green-700">
            Total Premium: ₹ {premium?.totalPremium}
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="overflow-y-auto space-y-6 pr-2 no-scrollbar">
          <FormSection title="Customer Details" defaultOpen={true}>
            <div className="grid grid-cols-12 gap-3">
              <div className="col-span-12 md:col-span-2">
                <label className="text-sm text-gray-600">
                  Title <span className="text-red-700">*</span>
                </label>
                <Select
                  name="title"
                  value={form.title}
                  onChange={handleSelectChange("title")}
                  options={["Mr.", "Mrs.", "Miss"]}
                />
                {errors.title && (
                  <p className="text-red-600 text-sm">{errors.title}</p>
                )}
              </div>

              <div className="col-span-12 md:col-span-5">
                <label className="text-sm text-gray-600">
                  Full Name <span className="text-red-700">*</span>
                </label>
                <Input
                  name="insuredName"
                  value={form.insuredName}
                  onChange={handleInputChange("insuredName")}
                />
                {errors.insuredName && (
                  <p className="text-red-600 text-sm">{errors.insuredName}</p>
                )}
              </div>

              <div className="col-span-12 md:col-span-5">
                <label className="text-sm text-gray-600">
                  Mobile <span className="text-red-700">*</span>
                </label>
                <Input
                  name="contactNumber"
                  value={form.contactNumber}
                  onChange={handleNumberChange("contactNumber")}
                />

                {errors.contactNumber && (
                  <p className="text-red-600 text-sm">{errors.contactNumber}</p>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
              <Input
                label="Email"
                name="email"
                value={form.email}
                onChange={handleInputChange("email")}
              />
              <div>
                <label className="text-sm text-gray-600">
                  Date of Birth <span className="text-red-700">*</span>
                </label>
                <Input
                  type="date"
                  name="dateOfBirth"
                  value={form.dateOfBirth}
                  onChange={handleInputChange("dateOfBirth")}
                />
                {errors.dateOfBirth && (
                  <p className="text-red-600 text-sm">{errors.dateOfBirth}</p>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
              <div>
                <label className="text-sm text-gray-600">
                  Document Type <span className="text-red-700">*</span>
                </label>
                <Select
                  name="documentType"
                  value={form.documentType}
                  onChange={handleSelectChange("documentType")}
                  options={["Select", "Aadhaar", "PAN"]}
                />
                {errors.documentType && (
                  <p className="text-red-600 text-sm">{errors.documentType}</p>
                )}
              </div>
              <div>
                <label className="text-sm text-gray-600">
                  Document Number <span className="text-red-700">*</span>
                </label>
                <Input
                  name="documentNumber"
                  value={form.documentNumber}
                  onChange={handlePANInputChange("documentNumber")}
                />
                {errors.documentNumber && (
                  <p className="text-red-600 text-sm">
                    {errors.documentNumber}
                  </p>
                )}
              </div>
            </div>
            <div className="gap-3 mt-3">
              <button
                className="px-6 py-2 bg-primary text-white rounded-lg font-semibold disabled:opacity-60"
                onClick={handleSaveCustomerDetails}
                disabled={saving}
              >
                {saving ? "Saving..." : "Save Draft"}
              </button>
            </div>
          </FormSection>

          {/* ADDRESS */}
          <FormSection title="Address" defaultOpen={false}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <label className="text-sm text-gray-600">
                  Communication Address <span className="text-red-700">*</span>
                </label>
                <Input
                  name="communicationAddress"
                  value={form.communicationAddress}
                  onChange={handleAddressInputChange("communicationAddress")}
                />
                {errors.communicationAddress && (
                  <p className="text-red-600 text-sm">
                    {errors.communicationAddress}
                  </p>
                )}
              </div>
              <div>
                <label className="text-sm text-gray-600">
                  Pincode <span className="text-red-700">*</span>
                </label>
                <Input
                  name="pinCode"
                  value={form.pinCode}
                  onChange={handleAddressInputChange("pinCode")}
                />
                {errors.pinCode && (
                  <p className="text-red-600 text-sm">{errors.pinCode}</p>
                )}
              </div>
              <div>
                <label className="text-sm text-gray-600">
                  District <span className="text-red-700">*</span>
                </label>
                <Input
                  name="district"
                  value={form.district}
                  onChange={handleInputChange("district")}
                />
                {errors.district && (
                  <p className="text-red-600 text-sm">{errors.district}</p>
                )}
              </div>
              <div>
                <label className="text-sm text-gray-600">
                  State <span className="text-red-700">*</span>
                </label>
                <Input
                  name="state"
                  value={form.state}
                  onChange={handleInputChange("state")}
                />
                {errors.state && (
                  <p className="text-red-600 text-sm">{errors.state}</p>
                )}
              </div>
            </div>
            <div className="gap-3 mt-3">
              <button
                className="px-6 py-2 bg-primary text-white rounded-lg font-semibold disabled:opacity-60"
                onClick={handleSaveAddress}
                disabled={saving}
              >
                {saving ? "Saving..." : "Save Draft"}
              </button>
            </div>
          </FormSection>

          {/* PROPERTY */}
          <FormSection title="Property Details" defaultOpen={false}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <Select
                  label="Construction Type"
                  name="constructionType"
                  value={form.constructionType}
                  onChange={handleSelectChange("constructionType")}
                  options={["Select", "Kutcha", "Pukka"]}
                />
                {errors.constructionType && (
                  <p className="text-red-600 text-sm mt-1">
                    {errors.constructionType}
                  </p>
                )}
              </div>

              <div>
                <Select
                  label="Ownership Type"
                  name="ownershipType"
                  value={form.ownershipType}
                  onChange={handleSelectChange("ownershipType")}
                  options={["Select", "Owned", "Rented"]}
                />
                {errors.ownershipType && (
                  <p className="text-red-600 text-sm mt-1">
                    {errors.ownershipType}
                  </p>
                )}
              </div>
            </div>

            <div className="gap-3 mt-3">
              <button
                className="px-6 py-2 bg-primary text-white rounded-lg font-semibold disabled:opacity-60"
                onClick={handleSaveProperty}
                disabled={saving}
              >
                {saving ? "Saving..." : "Save Draft"}
              </button>
            </div>
          </FormSection>

          {/* NOMINEE */}
          <FormSection title="Nominee" defaultOpen={false}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <label className="text-sm text-gray-600">
                  Nominee Name <span className="text-red-700">*</span>
                </label>
                <Input
                  name="nomineeName"
                  value={form.nomineeName}
                  onChange={handleInputChange("nomineeName")}
                />
                {errors.nomineeName && (
                  <p className="text-red-600 text-sm">{errors.nomineeName}</p>
                )}
              </div>
              <div>
                <label className="text-sm text-gray-600">
                  Nominee Relation <span className="text-red-700">*</span>
                </label>
                <Select
                  name="constructionType"
                  value={form.constructionType}
                  onChange={handleSelectChange("constructionType")}
                  options={[
                    "Select",
                    "Spouse",
                    "Father",
                    "Mother",
                    "Son",
                    "Daughter",
                    "Sister",
                    "Brother",
                  ]}
                />
                {errors.constructionType && (
                  <p className="text-red-600 text-sm">
                    {errors.constructionType}
                  </p>
                )}
              </div>
              <Input
                type="date"
                label="Nominee DOB"
                name="nomineeDateOfBirth"
                value={form.nomineeDateOfBirth}
                onChange={handleInputChange("nomineeDateOfBirth")}
              />
              <Input
                label="Nominee Contact"
                name="nomineeContactNumber"
                value={form.nomineeContactNumber}
                onChange={handleInputChange("nomineeContactNumber")}
              />
              <Select
                label="Document Type"
                name="nomineeDocumentType"
                value={form.nomineeDocumentType}
                onChange={handleSelectChange("nomineeDocumentType")}
                options={["Select Type", "Aadhaar", "PAN"]}
              />
              <Input
                label="Document Number"
                name="nomineeDocumentNumber"
                value={form.nomineeDocumentNumber}
                onChange={handleInputChange("nomineeDocumentNumber")}
              />
            </div>
            <div className="gap-3 mt-3">
              <button
                className="px-6 py-2 bg-primary text-white rounded-lg font-semibold disabled:opacity-60"
                onClick={handleSave}
                disabled={saving}
              >
                {saving ? "Saving..." : "Save Draft"}
              </button>
            </div>
          </FormSection>

          <div className="flex justify-end">
            <button
              className="px-6 py-3 bg-primary text-white rounded-lg font-semibold disabled:opacity-60"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? "Saving..." : "Save & Continue →"}
            </button>
          </div>
        </div>
      </div>

      {toast.message && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ message: "", type: "" })}
        />
      )}
    </div>
  );
};

const FormSection = ({ title, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="bg-white border rounded-2xl shadow">
      <div className="flex justify-between items-center p-6">
        <h3 className="text-lg font-semibold">{title}</h3>

        <button
          className="text-gray-500 text-xl px-6 hover:text-black"
          onClick={() => setOpen(!open)}
        >
          {open ? "−" : "+"}
        </button>
      </div>

      <div
        className={`transition-all duration-300 overflow-hidden ${
          open ? "max-h-[1000px] p-6 pt-0" : "max-h-0 px-6"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

const Input = ({ label, name, value, onChange, type = "text" }) => (
  <div>
    <label className="text-sm text-gray-600">{label}</label>
    <input
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      className="w-full border rounded-lg px-3 py-2 mt-1"
    />
  </div>
);

const Select = ({ label, name, value, onChange, options }) => (
  <div>
    <label className="text-sm text-gray-600">{label}</label>
    <select
      name={name}
      value={value}
      onChange={onChange}
      className="w-full border rounded-lg px-3 py-2 mt-1 bg-white"
    >
      {options.map((opt, i) => (
        <option key={i} value={opt}>
          {opt}
        </option>
      ))}
    </select>
  </div>
);

const Info = ({ label, value }) => (
  <div className="flex justify-between py-1 text-sm">
    <span className="text-gray-600">{label}</span>
    <span className="font-medium">₹ {value?.toLocaleString()}</span>
  </div>
);

export default CustomerDetails;
